import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/Button';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const { FiMenu, FiLogOut } = FiIcons;

const pageTitles = {
  '/': { title: 'Dashboard', subtitle: 'Real-time analytics & campaign insights' },
  '/upload': { title: 'Upload Users', subtitle: 'Import user data via CSV' },
  '/users': { title: 'All Users', subtitle: 'Manage and export user database' },
  '/logs': { title: 'API Logs', subtitle: 'Monitor system activity' },
};

const Header = ({ toggleSidebar }) => {
  const { logout } = useAuth();
  const location = useLocation();
  const page = pageTitles[location.pathname] || pageTitles['/'];

  return (
    <header className="flex h-16 items-center justify-between bg-white border-b border-surface-200 px-4 md:px-6 sticky top-0 z-30">
      <div className="flex items-center space-x-4">
        <button onClick={toggleSidebar} className="md:hidden p-2 rounded-xl text-surface-500 hover:bg-surface-100 transition-colors">
          <SafeIcon icon={FiMenu} className="w-5 h-5" />
        </button>
        <div>
          <h1 className="text-lg font-bold text-surface-800 leading-none">{page.title}</h1>
          <p className="text-xs text-surface-400 mt-0.5 hidden sm:block">{page.subtitle}</p>
        </div>
      </div>
      <div className="flex items-center space-x-4">
        <div className="flex items-center space-x-2 pl-3 border-l border-surface-200">
          <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-primary-500 to-accent-500 flex items-center justify-center text-white text-xs font-bold shadow-sm">A</div>
          <div className="hidden sm:block">
            <span className="block text-xs font-bold text-surface-700 leading-none">Administrator</span>
            <span className="text-[10px] text-surface-400 font-medium tracking-wide">System Access</span>
          </div>
        </div>
        <Button variant="ghost" size="sm" onClick={logout} className="text-surface-500 hover:text-red-600 hover:bg-red-50">
          <SafeIcon icon={FiLogOut} className="w-4 h-4" />
          <span className="hidden sm:inline ml-2">Logout</span>
        </Button>
      </div>
    </header>
  );
};

export default Header;